import { USStates } from 'constants/USStates';
import { uniq, uniqBy } from 'lodash';

/**
  * @example 
  *  ```JS 
      Input: [0, 0, 1, 3, 3, 7, 5]
      Output: [
        {
          originalValue: 0,
          orderValue: 0,
        },
        {
          originalValue: 1,
          orderValue: 1,
        },
        {
          originalValue: 3,
          orderValue: 2,
        },
        {
          originalValue: 7,
          orderValue: 3,
        },
        {
          originalValue: 5,
          orderValue: 4,
        },
      ]
  ```
*/
export const formatNumberSequence = (nums: number[]) => {
  const formattedValues: { originalValue: number; orderValue: number }[] = [];
  const uniqNums = uniq(nums);
  nums.forEach((num) => {
    formattedValues.push({
      originalValue: num,
      orderValue: uniqNums.indexOf(num),
    });
  });

  return uniqBy(formattedValues, 'orderValue');
};

export const getStateFromCode = (code: string) => {
  return USStates.find((state) => state.value === code)?.name || code;
};
